import { Alert, Button, Collapse, Container, Grid, IconButton, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useEffect, useState } from "react";
import { arrayUnion, doc, setDoc, Timestamp, updateDoc } from "firebase/firestore";
import { v4 } from 'uuid';
import { db } from "..";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import LinkIcon from '@mui/icons-material/Link';
import CloseIcon from '@mui/icons-material/Close';
import { CButton } from "../components";
import dayjs from 'dayjs';

export default function CreateHatmPage() {

    const [state, setState] = useState({});
    const [complete, setComplete] = useState(null);
    const id = v4().slice(0, 8)

    const [alert, setAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    let auth = getAuth()
    const navigate = useNavigate()

    onAuthStateChanged(auth, (user) => {
        if (user) {
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/firebase.User
            const uid = user.uid;
            // ...
        } else {
            // User is signed out
            window.location.href = '/giris';
        }
    });

    useEffect(() => {
        state.endDate = dayjs()
    }, [])

    const handleSubmit = (event) => {
        event.preventDefault();

        const data = new FormData(event.currentTarget);

        if (!(data.get('title') && state["endDate"])) {
            setAlertMessage("Boş alan bırakmayınız!")
            setAlert(true)
        } else {
            const endDate = new Date(`${state["endDate"]["$M"] + 1}.${state["endDate"]["$D"]}.${state["endDate"]["$y"]}`)

            let newState = state
            newState["title"] = data.get('title')
            newState["id"] = id

            setDoc(doc(db, "hatms", id), {
                date: Timestamp.now().toMillis(),
                endDate: endDate.getTime(),
                creator: auth.currentUser.uid,
                title: data.get('title'),
                juzs: {},
                id: id,
            }).then(() => {
                updateDoc(doc(db, "users", auth.currentUser.uid), {
                    [`hatms.${id}`]: {},
                }, { merge: true }).then(() => {
                    navigate(`/hatimler/${id}`)
                })
            })
        }


    };

    const endDate = state['endDate']


    return <Container>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Collapse in={alert}>
                <Alert
                    severity="error"
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setAlert(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                    {alertMessage}
                </Alert>
            </Collapse>

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="title"
                    label="Başlık"
                    name="title"
                    autoComplete="title"
                    autoFocus
                />
                <DatePicker
                    label="Bitiş Tarihi"
                    value={state["endDate"]}
                    required
                    onChange={(newValue) => {
                        console.log(newValue)
                        let newState = state
                        newState['endDate'] = newValue
                        setState({ ...newState })
                    }}
                    renderInput={(params) => <TextField fullWidth {...params} />}
                />

                <CButton
                    style={{ margin: "10px 0" }}
                    type="submit"
                    fullWidth
                    variant="contained"
                >
                    Hatim Oluştur
                </CButton>

            </Box>
        </LocalizationProvider>
    </Container>
}